import React from "react";
import PropTypes from 'prop-types';
import Banner from '../Banner';
import CloseIcon from '../icons/Close';

export const TYPE_SUCCESS = 'success';
export const TYPE_ERROR = 'error';
export const TYPE_INFO = 'info';

const transition = .3;
export default class MessageBanner extends React.PureComponent {
    state = {
        isClose: false,
    };
    componentDidMount() {
        document.addEventListener("keydown", this.keyDownHandler);
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.keyDownHandler);
    }
    keyDownHandler = (e) => {
        if (e.keyCode === 27) {
            this.onClose();
        }
    };
    onClose = () => {
        let { onCloseCallback } = this.props;
        this.setState({
            isClose: true,
        });

        setTimeout(onCloseCallback, transition * 1000);
    };
    render() {
        let { children, type, isNoAutoClose, onCloseCallback, className } = this.props;
        let { isClose } = this.state;

        return (
            <Banner
                onCloseCallback={onCloseCallback}
                isNoAutoClose={isNoAutoClose}
                className={`message-banner${isClose ? ' close' : ''}${type ? ` ${type}` : ''} ${className ? ` ${className}` : ''}`}
                button={<CloseIcon onClick={this.onClose}/>}>{children}</Banner>
        );
    }
}

MessageBanner.propTypes = {
    type: PropTypes.oneOf([
        TYPE_SUCCESS,
        TYPE_ERROR,
        TYPE_INFO,
    ]),
    children: PropTypes.node.isRequired,
    onCloseCallback: PropTypes.func.isRequired,
    isNoAutoClose: PropTypes.bool,
    className: PropTypes.string,
};
